import { service } from "@/ajax/request";
import { AxiosPromise } from "axios";

export const sleepMonitorList = (params): AxiosPromise =>{
    return service({
        url: `/sleep-monitor/list`,
        method: "POST",
        params,
      });
}

export const bindingRecords = (params): AxiosPromise => {
    return service({
        url: `/sleep-monitor/binding-records`,
        method: "POST",
        params,
      });
}

export const unBind = (params): AxiosPromise => {
  return service({
      url: `/sleep-monitor/release-binding`,
      method: "POST",
      params
    });
}
